__turbopack_context__.v({
  "host": "ToastNotificationContainer-module__YzkDXa__host",
  "toast": "ToastNotificationContainer-module__YzkDXa__toast",
});
